module.exports = __webpack_public_path__ + "img/kn.1e49a486.svg";